import React, { useEffect, useRef, useState } from "react";
import styles from './AutoComplete.module.scss';
import TextField from "../textField/TextField";
import PropTypes from "prop-types";
import useClickOutside from "../../hooks/useClickOutside";

const AutoComplete = ({
  label,
  value,
  placeholder,
  onChange,
  disabled,
  error,
  list
}) => {
  const [textValue, setTextValue] = useState('');
  const [showList, setShowList] = useState(false);
  const [filteredList, setFilteredList] = useState(list);
  const containerRef = useRef(null); 

  useEffect(() => {
    setTextValue(value);
  }, [value])

  useClickOutside(containerRef, () => setShowList(false));

  const handleChange = (value) => {
    if (value) {
      setFilteredList(list.filter(item =>
        item.toLowerCase().includes(value.toLowerCase())
      ));
    } else {
      setFilteredList(list);
    }
    setShowList(true);
    setTextValue(value);
    onChange(value);
  }

  const handleSelect = (item) => {
    setTextValue(item);
    onChange(item);
    setShowList(false);
  };

  return (
    <div className={styles.container} ref={containerRef}>
      <TextField
        label={label}
        type="text"
        value={textValue}
        placeholder={placeholder}
        onChange={handleChange}
        onClick={() => handleChange(textValue)}
        disabled={disabled}
        error={error}
      />
      {showList && filteredList.length > 0 && <ul className={styles.list}>
        {filteredList.map((item)=> {
          return (
            <li
              onClick={() => handleSelect(item)}
              key={item}
            >
              {item}
            </li>
          );
        })}
      </ul>}
    </div>
  );
};

AutoComplete.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
}

export default AutoComplete;